import { createAnnotation } from "@pages/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

/**
 * Renders a bulleted list element in an article.
 * This component processes the body string to extract list items and applies appropriate styles and classes.
 */
const ListBulleted = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps): React.ReactElement => {
  const transformAnnotation = createAnnotation({});

  const transformList = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "ul") {
      const el = node;

      const children = el.children as DOMNode[];

      return (
        <ul
          className={cn(
            "mb-6 list-outside list-disc",
            className,
            paragraphWidth,
            "[&>ul]:list-outside [&>ul]:list-decimal [&>ul]:pl-8",
            "pl-8 md:pl-8" // enure consistent padding across types
          )}
          data-testid="article-list-bulleted-component"
        >
          {domToReact(children, {
            replace: (childNode: DOMNode) => {
              if (childNode.type === "tag" && childNode.name === "li") {
                const listItem = childNode;
                const listItemChildren = listItem.children as DOMNode[];

                return (
                  <li className="whitespace-pre-wrap text-xl">
                    {domToReact(listItemChildren, {
                      replace: transformAnnotation,
                    })}
                  </li>
                );
              }

              return childNode;
            },
          })}
        </ul>
      );
    }
  };

  return <>{parse(bodyString, { replace: transformList })}</>;
};

export default ListBulleted;
